import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class RemoveWorkflowRunSource {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly runId: number,
		public readonly sourceId: number,
	) {
		Object.freeze(this);
	}
}

export default RemoveWorkflowRunSource;
